import styled from "styled-components";

const StyledContextualDropDownWrapper = styled.div`
  margin-top: ${({ theme }) => theme.dropdownOffset};
  padding: ${({ theme }) => theme.dropdownPadding};
  border: 1px solid ${({ theme }) => theme.dropdownBorderColor};
  border-radius: ${({ theme }) => theme.dropdownBorderRadius};
  box-shadow: ${({ theme }) => theme.dropdownShadowSize}
    ${({ theme }) => theme.dropdownShadowColor};
  background: ${({ theme }) => theme.dropdownBackgroundColor};
  //overflow: hidden;
  z-index: ${({ theme }) => theme.dropdownZIndex};
`;

export default StyledContextualDropDownWrapper;
